import { close, expandIcon, newWindowIcon } from "@/components/icons/SVGIcons";
// import {
//   newPopOutWindow,
//   onDeleteItem,
//   returnCurrentTabID,
//   returnCurrentTabStateJSON,
// } from "@/lib/widgetHelperFunctions";
// import { IWidgetDetails } from "@/lib/widgetsLayoutDir";
import {
  newPopOutWindow,
  onDeleteItem,
  returnCurrentTabID,
  returnCurrentTabStateJSON,
} from "@/lib/widgetHelperFunctions";
import { baseWidgetDetails, IWidgetDetails } from "@/lib/widgetsLayoutDir";
import useTableUIStore from "@/store/tableUIStore";
import workspacesTabsStore from "@/store/workspacesTabsStore";
import { Layout } from "react-grid-layout";
import {
  getWidgetHeaderFontClass,
  getWidgetHeaderIconSize,
  getWidgetHeaderSizeClass,
} from "@/components/widgets/tradeActionSummary/helper/actionSummaryHelper";
import WidgetHeaderPriceConfigName, {
  PRICE_WIDGET_COMPONENT_KEY,
} from "./WidgetHeaderPriceConfigName";
import WidgetHeaderHistoricalSearch, {
  HISTORICAL_SEARCH_COMPONENT_KEYS,
} from "./WidgetHeaderHistoricalSearch";

const WidgetHeader = ({ widget, l }: { widget: IWidgetDetails; l: Layout }) => {
  const updateWholeTab = workspacesTabsStore((state) => state.updateWholeTab);
  const fontSize = useTableUIStore((state) => state.fontSize);
  const headerFontClass = getWidgetHeaderFontClass(fontSize);
  const iconBtnSize = getWidgetHeaderIconSize(fontSize);
  const headerSizeClass = getWidgetHeaderSizeClass(fontSize);

  function getWidgetNameFromDirectory(widget: IWidgetDetails) {
    const directoryName = baseWidgetDetails.find(
      (ele) => ele.component == widget.component,
    )?.displayName;
    if (directoryName) {
      return directoryName;
    }
    return widget.displayName;
  }

  return (
    <div
      className={`widgetHandler ${headerSizeClass} flex h-6 w-full cursor-move items-center justify-between rounded-t-lg border-gray-700 bg-cubeBase-700 px-2 dark:bg-cubeBaseDark-700`}
    >
      <div
        id={widget.component}
        className={`${headerFontClass}  flex h-full min-w-0 items-center overflow-hidden font-semibold`}
      >
        <span className="truncate">
          {widget && getWidgetNameFromDirectory(widget)}
        </span>
        {/* LQC-2575 - the Prices widget also names its active config here. */}
        {widget && widget.component == PRICE_WIDGET_COMPONENT_KEY && (
          <WidgetHeaderPriceConfigName cryptoID={l.i} />
        )}
        {widget &&
          HISTORICAL_SEARCH_COMPONENT_KEYS.includes(widget.component) && (
            <WidgetHeaderHistoricalSearch cryptoID={l.i} />
          )}
      </div>
      <div className="flex items-center">
        {widget && widget.i.includes("Tile") ? (
          <div
            className={`hide-button-fromDrag flex ${iconBtnSize} items-center justify-center rounded text-cubeBase-600 hover:cursor-pointer hover:bg-[#cdcdcd]  hover:text-black dark:text-cubeBaseDark-600 hover:dark:bg-[#45464d] dark:hover:text-white`}
            id={l.i}
            onClick={() => {
              newPopOutWindow(l.i, widget.esid);
            }}
          >
            {newWindowIcon}
          </div>
        ) : (
          <div></div>
        )}
        <div
          className={`hide-button-fromDrag flex ${iconBtnSize} items-center justify-center rounded text-cubeBase-600 hover:cursor-pointer hover:bg-[#cdcdcd]  hover:text-black dark:text-cubeBaseDark-600 hover:dark:bg-[#45464d] dark:hover:text-white`}
          id="widgetExpandButton"
          onClick={() => {
            const expandedWidgetId = widget.i;
            const currentTabStateJSON = returnCurrentTabStateJSON();
            const currentTabId = returnCurrentTabID();

            //expand and contract widget for large layouts
            currentTabStateJSON.layouts.lg.map((layoutWidget: any) => {
              if (layoutWidget.i == expandedWidgetId) {
                if (layoutWidget.w == 12 && layoutWidget.h >= 20) {
                  layoutWidget.w = 6;
                  layoutWidget.h = 10;
                } else {
                  layoutWidget.w = 12;
                  layoutWidget.h = 20;
                }
              }
            });

            //expand widget for small layouts
            currentTabStateJSON.layouts.sm.map((layoutWidget: any) => {
              if (layoutWidget.i == expandedWidgetId) {
                layoutWidget.w = 4;
                layoutWidget.h = 9;
              }
            });

            // Update the store directly rather than DB/API call, the onLayoutChange will note the change and make the API call once.
            if (currentTabId) {
              updateWholeTab(currentTabStateJSON, currentTabId);
            }
          }}
        >
          {expandIcon}
        </div>
        <div
          className={`hide-button-fromDrag flex ${iconBtnSize} items-center justify-center rounded text-cubeBase-600 hover:cursor-pointer hover:bg-red-500  hover:text-black dark:text-cubeBaseDark-600 hover:dark:bg-red-500 dark:hover:text-white`}
          onClick={() => onDeleteItem(l)}
        >
          {close}
        </div>
      </div>
    </div>
  );
};

export default WidgetHeader;
